/* angular:styles/component:css;a21f75bac23368cfaf3136c1d0e2f5c3902ac53059939bc9e28405e0107e402e;/opt/atlassian/pipelines/agent/build/src/app/tab-configurations/tab-configurations.page.ts */
ion-item {
  --highlight-background: transparent !important;
}
ion-item div.label-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-grow: 1;
  align-items: center;
}
ion-item ion-button.rename-button {
  --padding-end: 8px;
  --padding-start: 12px;
  margin-left: auto;
}
ion-item ion-button.delete-button {
  --padding-end: 8px;
  --padding-start: 12px;
  margin-left: 0.5rem;
}
/*# sourceMappingURL=tab-configurations.page.css.map */
